import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"search\"><path d=\"M11.429 10.057h-.732l-.274-.274a5.724 5.724 0 0 0 1.463-3.84A5.931 5.931 0 0 0 5.943 0 5.93 5.93 0 0 0 0 5.943a5.931 5.931 0 0 0 5.943 5.943 5.724 5.724 0 0 0 3.84-1.463l.274.274v.732L14.629 16 16 14.629l-4.571-4.572zm-5.486 0a4.096 4.096 0 0 1-4.114-4.114 4.096 4.096 0 0 1 4.114-4.114 4.096 4.096 0 0 1 4.114 4.114 4.096 4.096 0 0 1-4.114 4.114z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol